// @flow
import Cookies from 'js-cookie'

const POLICY_COOKIE_NAME = 'cookie-policy-warning'

export const cookieExists = () => !!Cookies.get(POLICY_COOKIE_NAME)

export const setCookie = () =>
  Cookies.set(POLICY_COOKIE_NAME, 'Read', { expires: 730, path: '/' })
